import { create } from 'zustand';
import { AuditorCompetence } from '@/common';
import { FormType } from '../../types';

const INITIAL_FORM_STATE: FormType = {
  note: '',
  workExperience: '',
  education: '',
  training: '',
  workplaceTraining: '',
  statusNote: '',
  standard: null,
  class: null,
  auditorCategory: null,
  status: null,
};

type CreatePageState = {
  form: FormType;
  competences: AuditorCompetence[];
};

type CreatePageActions = {
  setForm: (form: FormType) => void;
  setCompetences: (competences: AuditorCompetence[]) => void;
  reset: () => void;
};

export const useCreatePageStore = create<CreatePageState & CreatePageActions>((set) => ({
  form: { ...INITIAL_FORM_STATE },
  competences: [],
  setForm: (form: FormType) => set({ form }),
  setCompetences: (competences: AuditorCompetence[]) => set({ competences }),
  reset: () => set({ form: { ...INITIAL_FORM_STATE }, competences: [] }),
}));
